import { apiClient } from './api/client';

export type VelosterHealthLevel =
  | 'operational'
  | 'degraded'
  | 'outage'
  | 'scheduled_off'
  | 'unknown';

/** Espelha `GpuTelemetry` do backend (document-comparison/core/inference). */
export interface GpuTelemetry {
  id: string;
  ready: boolean;
  temp_c?: number;
  util_pct?: number;
  mem_used_mb?: number;
  mem_total_mb?: number;
}

/** Espelha `VelosterHealthDto` do backend (GET /veloster/health). */
export interface VelosterHealthStatus {
  level: VelosterHealthLevel;
  gpus: GpuTelemetry[];
  counts: Record<string, number>;
  failureRate: number;
  checkedAt: string;
}

export const velosterHealthService = {
  getStatus: (): Promise<VelosterHealthStatus> =>
    apiClient.get('/veloster/health').then((r) => r.data),
};
